import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GetLocalStorage } from '../../../../../components/commonClass/Session';
import { getAllData, postUsersData } from '../../../../../services/ApiCallingUserServices';
import { formatDateyyyymmdd } from '../../../../../components/commonClass/CommonValidation';
import { getSortedData } from '../../../../../components/commonClass/DataSorting';
import { getAirlineLogo } from '../../../../../components/commonClass/CommonFunctions';
import AlertModel from '../../../../../customControl/AlertModel';

const FlightFilter = ({ filterFlightList, setFlightList, flightList, formValue, searchParams, datalist }: any) => {
    const dispatch = useDispatch();
    const userData: any = GetLocalStorage();
    const IsLoginModel = useSelector((state: any) => state.loginModeleShowOrHideReducer)
    const [showSideFilter, setShowSideFilter] = useState(false);
    const [derret, setDepRet] = useState('Departure');
    const [showMoreCity, setShowMoreCity] = useState(5);
    const [priceAlert, setPriceAlert] = useState({
        UserMasterId: userData?.userMasterID,
        IsPriceAlert: false
    });
    const [formFilterTime, setFormFilterTime] = useState<any>({
        DepartureStartTime: null,
        DepartureEndTime: null,
        ArrivalStartTime: null,
        ArrivalEndTime: null,
        ReturnDepartureStartTime: null,
        ReturnDepartureEndTime: null,
        ReturnArrivalStartTime: null,
        ReturnArrivalEndTime: null,
        DirectFlight: false,
        OneStopFlight: false,
        IsAllowedOvernightStopOvers: false,
        PreferredAirlines: [],
        price: 0
    })

    const timeSlots = [
        {
            id: 1,
            startTime: "00:00:00",
            endTime: "06:00:00",
            label: "Before 6 AM"
        },
        {
            id: 2,
            startTime: "06:00:00",
            endTime: "12:00:00",
            label: "6 AM to 12 PM"
        },
        {
            id: 3,
            startTime: "12:00:00",
            endTime: "18:00:00",
            label: "12 PM to 6 PM"
        },
        {
            id: 4,
            startTime: "18:00:00",
            endTime: "00:00:00",
            label: "After 6 PM"
        },
    ]

    const [timeFilters, setTimeFilters] = useState<any>({
        Departure: { ids: [], timeSlots: [] },
        Arrival: { ids: [], timeSlots: [] },
        ReturnDeparture: { ids: [], timeSlots: [] },
        ReturnArrival: { ids: [], timeSlots: [] },
    })


    const [showModal, setShowModal] = useState(false);
    const [unsubscribeSuccessfully, setUnsubscribeSuccessfully] = useState(false);
    const [priceFilter, setPriceFilter] = useState(formFilterTime?.price);
    const [minMaxPrice, setMinMaxPrice] = useState({
        maxPrice: 0,
        minPrice: 0
    })

    useEffect(() => {
        if (filterFlightList?.length > 0) {
            let maxPrice = Math.max(...filterFlightList?.map((obj: any) => obj?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson)) || 0;
            let minPrice = Math.min(...filterFlightList?.map((obj: any) => obj?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson)) || 0;
            setMinMaxPrice((prev) => ({
                ...prev,
                maxPrice: Math.ceil(maxPrice),
                minPrice: Math.floor(minPrice)
            }))
        }
    }, [filterFlightList])

    useEffect(() => {
        if (formFilterTime?.price === 0) {
            setPriceFilter(minMaxPrice?.maxPrice);
        }
        else {
            setPriceFilter(formFilterTime?.price);
        }
    }, [minMaxPrice?.maxPrice, formFilterTime?.price])

    const toggleSideFilter = () => {
        setShowSideFilter((prev) => !prev);
    }

    const updatePriceAlert = async (value: any) => {
        await postUsersData('/customerui/v1/insertorupdateusermasterpricealert', { ...priceAlert, IsPriceAlert: value }).then((rep: any) => {
            setShowModal(false)
            setPriceAlert({ ...priceAlert, IsPriceAlert: value })
            !value && setUnsubscribeSuccessfully(true)
        })
    }

    const getPriceAlert = async () => {
        await getAllData(`/customerui/v1/getusermasterprofilebyid?userMasterId=${userData?.userMasterID}`).then((rep: any) => {
            setPriceAlert({ ...priceAlert, IsPriceAlert: rep?.data?.IsPriceAlert })
        })
    }
    useEffect(() => {
        if (!IsLoginModel && userData?.userMasterID) {
            getPriceAlert();
        }
    }, [userData?.userMasterID, IsLoginModel])

    const handleOnChange = (name: any, val: any, check = false) => {
        let filterData = { ...formFilterTime }
        if (name === 'any') {
            filterData = { ...filterData, DirectFlight: false, OneStopFlight: false, IsAllowedOvernightStopOvers: false }
        }
        else if (name === 'direct') {
            filterData = { ...filterData, DirectFlight: true, OneStopFlight: false, IsAllowedOvernightStopOvers: false }
        }
        else if (name === 'uptoStops1') {
            filterData = { ...filterData, DirectFlight: false, OneStopFlight: true, IsAllowedOvernightStopOvers: false }
        }
        else if (name === 'allowOvernightStopovers' && check) {
            filterData = { ...filterData, DirectFlight: false, IsAllowedOvernightStopOvers: formFilterTime?.IsAllowedOvernightStopOvers ? false : true, OneStopFlight: true, }
        }
        setFormFilterTime(filterData);
    }
    const airlineChange = (name: any, val: any) => {
        let filterData: any = { ...formFilterTime }
        if (!filterData?.PreferredAirlines?.includes(val)) {
            filterData = {
                ...filterData,
                PreferredAirlines: [...filterData.PreferredAirlines, val]
            }
        }
        else {
            filterData = {
                ...filterData,
                PreferredAirlines: filterData.PreferredAirlines.filter((airline: any) => airline !== val)
            }
        }
        setFormFilterTime(filterData);
    }

    const hendlechage = (name: any, val: any) => {
        setPriceFilter(val)
    }

    const handlePriceChangeComplete = (e: any) => {
        let filterData = { ...formFilterTime }
        filterData = { ...filterData, price: Number(priceFilter) }
        setFormFilterTime(filterData);
    };

    const getcity = () => {
        const urlParams = new URLSearchParams(searchParams);
        const fromcity = datalist?.cityList?.find((el: any) => el.CityCode === urlParams.get("fcc"))?.City;
        const tocity = datalist?.cityList?.find((el: any) => el.CityCode === urlParams.get("tcc"))?.City;
        return { fromcity, tocity };
    }

    const hendledepret = (val: any) => {
        setDepRet(val)
    }

    const handlePriceAlert = (value: any) => {
        if (userData) {
            if (!value) {
                setShowModal(true)
            } else {
                updatePriceAlert(value);
            }
        }
        else {
            dispatch({ type: "SHOW_OR_HIDE_LOGIN_MODEL", payload: true })
        }
    }

    const onClosedModal = () => {
        setShowModal(false);
    }

    //#region functions and params for filter and sorting

    useEffect(() => {
        let isdomesticFlightrtn = (formValue?.JourneyType === 2 && sessionStorage.getItem('isinternational') === 'false')
        let isinternationalrtn = (formValue?.JourneyType === 2 && sessionStorage.getItem('isinternational') === 'true')
        const getDepTime = (el: any) => el?.segments?.[0]?.[0]?.origin?.depTime;
        const getArrTime = (el: any) => el?.segments?.[0]?.[el?.segments?.[0]?.length - 1]?.destination?.arrTime;
        const getRetDepTime = (el: any) => isinternationalrtn ? el?.segments?.[1]?.[0]?.origin?.depTime : el?.segments?.[0]?.[0]?.origin?.depTime;
        const getRetArrTime = (el: any) => isinternationalrtn ? el?.segments?.[1]?.[el?.segments?.[1]?.length - 1]?.destination?.arrTime : el?.segments?.[0]?.[el?.segments?.[0]?.length - 1]?.destination?.arrTime;
        const getFightStop = (el: any) => {
            if (isinternationalrtn || formValue?.JourneyType === 3) {
                const lengths = (el?.segments || [])?.map((s: any) => s?.length || 0);
                return lengths.length ? Math.max(...lengths) : 0;
            }
            else {
                return el?.segments?.[0]?.length
            }
        }
        const getAirline = (el: any) => {
            const code: any = []
            el?.segments?.map((ele: any) => {
                ele?.forEach((obj: any) => {
                    if (!code?.includes(obj.airline.airlineCode))
                        code.push(obj.airline.airlineCode);
                });
            })
            return code
        }
        const getPrice = (el: any) => el?.listPriceValue
        // const inRange = (rawTime, start, end) => {
        //     if (!rawTime) return false;
        //     const base = formatDateyyyymmdd(rawTime, "-");
        //     const t = new Date(rawTime)?.getTime();
        //     const from = start ? new Date(`${base}T${start}`)?.getTime() : null;
        //     const to = end ? new Date(`${base}T${end}`)?.getTime() : null;

        //     if (from && !to) return t <= from;
        //     if (from && to) return t >= from && t <= to;
        //     if (!from && to) return t >= to;
        //     return true;
        // };
        const inRange = (rawTime: any, slots: any) => {
            if (!rawTime) return true;
            if (!slots?.length) return true;

            const base = formatDateyyyymmdd(rawTime, "-");
            const t: any = new Date(rawTime)?.getTime();
            return slots?.some((slotKey: any) => {
                const fromDate = new Date(`${base}T${slotKey?.startTime}`);
                const toDate = new Date(`${base}T${slotKey?.endTime}`);

                const nextDayMidNightTime = slotKey?.endTime === "00:00:00" ? new Date(toDate?.setDate(toDate?.getDate() + 1))?.getTime() : toDate?.getTime()

                const from: any = slotKey?.startTime ? fromDate?.getTime() : null;
                const to: any = slotKey?.endTime ? nextDayMidNightTime : null;

                return t >= from && t < to;
            })
        };

        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

        const filtered = filterFlightList?.filter((el: any) => {
            if (isdomesticFlightrtn) {
                const depOk = el?.isFromCity ? inRange(getDepTime(el), timeFilters?.Departure?.timeSlots) : true;
                const arrOk = el?.isFromCity ? inRange(getArrTime(el), timeFilters?.Arrival?.timeSlots) : true;
                const rtndepOk = !el?.isFromCity ? inRange(getRetDepTime(el), timeFilters?.ReturnDeparture?.timeSlots) : true;
                const rtnarrOk = !el?.isFromCity ? inRange(getRetArrTime(el), timeFilters?.ReturnArrival?.timeSlots) : true;
                const directOk = formFilterTime?.DirectFlight ? getFightStop(el) === 1 : true;
                const oneStopOk = formFilterTime?.OneStopFlight ? getFightStop(el) === 2 : true;
                const airlineOk = formFilterTime?.PreferredAirlines?.length > 0 ?
                    getAirline(el)?.every((v: any) => formFilterTime?.PreferredAirlines?.map((x: any) => x?.toLowerCase())?.includes(v.toLowerCase()))
                    : true;
                const priceOk = formFilterTime?.price > 0 ? getPrice(el) <= formFilterTime?.price : true
                return depOk && arrOk && rtndepOk && rtnarrOk && directOk && oneStopOk && airlineOk && priceOk;
            }
            if (isinternationalrtn) {
                const depOk = inRange(getDepTime(el), timeFilters?.Departure?.timeSlots);
                const arrOk = inRange(getArrTime(el), timeFilters?.Arrival?.timeSlots);
                const rtndepOk = inRange(getRetDepTime(el), timeFilters?.ReturnDeparture?.timeSlots);
                const rtnarrOk = inRange(getRetArrTime(el), timeFilters?.ReturnArrival?.timeSlots);
                const directOk = formFilterTime?.DirectFlight ? getFightStop(el) === 1 : true;
                const oneStopOk = formFilterTime?.OneStopFlight ? getFightStop(el) === 2 : true;
                const airlineOk = formFilterTime?.PreferredAirlines?.length > 0 ?
                    getAirline(el)?.every((v: any) => formFilterTime?.PreferredAirlines?.map((x: any) => x?.toLowerCase())?.includes(v.toLowerCase()))
                    : true;
                const priceOk = formFilterTime?.price > 0 ? getPrice(el) <= formFilterTime?.price : true
                return depOk && arrOk && rtndepOk && rtnarrOk && directOk && oneStopOk && airlineOk && priceOk;
            }
            else {
                // const depOk = inRange(getDepTime(el), formFilterTime?.DepartureStartTime, formFilterTime?.DepartureEndTime);
                const depOk = inRange(getDepTime(el), timeFilters?.Departure?.timeSlots);
                const arrOk = inRange(getArrTime(el), timeFilters?.Arrival?.timeSlots);
                const directOk = formFilterTime?.DirectFlight ? getFightStop(el) === 1 : true;
                const oneStopOk = formFilterTime?.OneStopFlight ? getFightStop(el) === 2 : true;
                const airlineOk = formFilterTime?.PreferredAirlines?.length > 0 ?
                    getAirline(el)?.every((v: any) => formFilterTime?.PreferredAirlines?.map((x: any) => x?.toLowerCase())?.includes(v.toLowerCase()))
                    : true;
                const priceOk = formFilterTime?.price > 0 ? getPrice(el) <= formFilterTime?.price : true
                return depOk && arrOk && directOk && oneStopOk && airlineOk && priceOk;
            }
        });
        // setFlightList(filtered?.length ? filtered : filterFlightList);

        // sorting
        const sortingFiltered = filtered?.slice();

        if (isdomesticFlightrtn) {
            setFlightList(sortingFiltered);
        }
        else {
            const column = formValue?.IsCheapest ? "listPriceValue" : formValue?.IsFastest ? "totalTimeDuration" : "";
            const sortedList = column === "" ? sortingFiltered : getSortedData(sortingFiltered, true, column, "number");
            setFlightList(sortedList);
        }
        // setFlightList(filtered);
    }, [formFilterTime, timeFilters, formValue, filterFlightList])
    //#endregion

    useEffect(() => {
        setFormFilterTime({
            DepartureStartTime: null,
            DepartureEndTime: null,
            ArrivalStartTime: null,
            ArrivalEndTime: null,
            ReturnArrivalEndTime: null,
            ReturnArrivalStartTime: null,
            ReturnDepartureEndTime: null,
            ReturnDepartureStartTime: null,
            DirectFlight: false,
            OneStopFlight: false,
            IsAllowedOvernightStopOvers: false,
            PreferredAirlines: [],
            price: 0
        })

        setTimeFilters({
            Departure: { ids: [], timeSlots: [] },
            Arrival: { ids: [], timeSlots: [] },
            ReturnDeparture: { ids: [], timeSlots: [] },
            ReturnArrival: { ids: [], timeSlots: [] },
        })

    }, [filterFlightList])

    // const handleTimeSlotFilter = (nameOne, nameTwo, valOne, valTwo, type, isChecked) => {
    //     if (isChecked) {
    //         setFormFilterTime((previousData) => ({
    //             ...previousData,
    //             [nameOne]: valOne ? valOne : null,
    //             [nameTwo]: valTwo ? valTwo : null
    //         }));

    //     } else {
    //         setFormFilterTime((previousData) => ({ ...previousData, [nameOne]: null, [nameTwo]: null }));
    //     }
    // }

    const handleChangeTimeSlotFilter = (name: any, slotId: any, slot: any, isChecked: any) => {
        if (isChecked) {
            setTimeFilters((prev: any) => ({
                ...prev,
                [name]: { ids: [...prev?.[name]?.ids, slotId], timeSlots: [...prev?.[name]?.timeSlots, slot] }
            }))
        } else {
            setTimeFilters((prev: any) => ({ ...prev, [name]: { ids: prev?.[name]?.ids?.filter((item: any) => item !== slotId), timeSlots: prev?.[name]?.timeSlots?.filter((item: any) => item.id !== slotId) } }))
        }
    }
    return (
        <>
            <span className="openSideFilter" onClick={toggleSideFilter}>
                <i className="fa-solid fa-filter"></i> Filter
            </span>

            <div id="sideFilter" className={showSideFilter ? "sideFilter showFilter" : "sideFilter"}>
                <div className="filterDiv" style={{ position: (showModal || unsubscribeSuccessfully) ? 'relative' : 'sticky' }}>
                    <i className="closeSideFilter fa-solid fa-xmark" onClick={() => toggleSideFilter()}></i>
                    <div className="set-price-alert">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h4>Set up price alerts</h4>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    style={{ zIndex: 0 }}
                                    id="flexSwitchCheckDefault"
                                    checked={priceAlert?.IsPriceAlert}
                                    onChange={(e) => handlePriceAlert(e.target.checked)}
                                />
                            </div>
                        </div>
                        <p>Receive alerts when the prices for this route change.</p>
                    </div>

                    <div className="accordion" id="accordionPanelsStayOpenExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFilter1">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                    aria-controls="panelsStayOpen-collapseOne">
                                    Stops
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show"
                                aria-labelledby="leftFilter1">
                                <div className="accordion-body">
                                    <ul>
                                        <li>
                                            <div className="form-check">
                                                <input className="form-check-input cursor_pointer"
                                                    checked={formFilterTime?.DirectFlight === false && formFilterTime?.OneStopFlight === false && formFilterTime?.IsAllowedOvernightStopOvers === false}
                                                    onChange={(e) => handleOnChange('any', 'any',)}
                                                    type="radio" name="stops" id="any" />
                                                <label className="form-check-label" htmlFor="any">Any</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-check">
                                                <input className="form-check-input cursor_pointer"
                                                    checked={formFilterTime?.DirectFlight === true}
                                                    onChange={(e) => handleOnChange('direct', 'direct',)}
                                                    type="radio" name="stops" id="direct" />
                                                <label className="form-check-label" htmlFor="direct">Direct</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-check">
                                                <input className="form-check-input cursor_pointer"
                                                    checked={formFilterTime?.OneStopFlight === true}
                                                    onChange={(e) => handleOnChange('uptoStops1', 'uptoStops1',)}
                                                    type="radio" name="stops" id="uptoStops1" />
                                                <label className="form-check-label" htmlFor="uptoStops1">Up to 1 stop</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-check">
                                                <input className="form-check-input cursor_pointer"
                                                    checked={formFilterTime?.OneStopFlight === true && formFilterTime?.IsAllowedOvernightStopOvers === true}
                                                    onChange={(e) => handleOnChange('allowOvernightStopovers', 'allowOvernightStopovers', true)} type="checkbox" value="" id="allowOvernightStopovers" />
                                                <label className="form-check-label" htmlFor="allowOvernightStopovers">
                                                    Allow overnight stopovers
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFilter2">
                                <button
                                    className="accordion-button"
                                    type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo"
                                    aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo"
                                >
                                    Airlines
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse show"
                                aria-labelledby="leftFilter2">
                                <div className="accordion-body">
                                    <ul style={{ minHeight: "auto", maxHeight: "250px", overflow: "auto" }}>
                                        {datalist?.airlineList?.length > 0 && datalist?.airlineList?.slice(0, showMoreCity)?.map((el: any, index: any) => (
                                            <li key={index}>
                                                <div className="form-check">
                                                    <input className="form-check-input cursor_pointer" onChange={(e) => airlineChange("PreferredAirlines", el?.AirlineCode)} checked={formFilterTime?.PreferredAirlines?.includes(el?.AirlineCode)} name="PreferredAirlines" type="checkbox" id={el?.AirlineID} />
                                                    <label className="form-check-label" htmlFor={el?.AirlineID}>
                                                        <img src={getAirlineLogo(el?.AirlineCode)}
                                                            onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                            loading="lazy"
                                                            height="20px" width="20px"
                                                            className='rounded me-1'
                                                            title={el?.AirlineName}
                                                            alt="flights logo"
                                                        />
                                                        {el?.AirlineName}
                                                    </label>
                                                </div>
                                            </li>
                                        ))}
                                        {datalist?.airlineList?.length > 5 ? showMoreCity <= 5 ?
                                            <li className='more_city cursor_ponter' onClick={() => setShowMoreCity(datalist?.airlineList?.length)}>
                                                See more Airline
                                            </li> :
                                            <li className='more_city' onClick={() => setShowMoreCity(5)}>
                                                Show less Airline
                                            </li> : ''
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {formValue?.JourneyType !== 3 && <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFilter3">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                                    aria-controls="panelsStayOpen-collapseThree">
                                    Times
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse show"
                                aria-labelledby="leftFilter3">
                                <div className="accordion-body">
                                    <div className='filter_flight'>
                                        <ul className='d-flex align-items-center'>
                                            <li className={` ${derret === 'Departure' ? 'active' : ''}`}>
                                                <button onClick={() => hendledepret('Departure')} type='button' className='w-100 bg-body border-0'>Departure</button>
                                            </li>
                                            {formValue?.JourneyType === 2 && <li className={` ${derret === 'Return' ? 'active' : ''}`}>
                                                <button onClick={() => hendledepret('Return')} type='button' className='w-100 bg-body border-0'>Return</button>
                                            </li>}
                                        </ul>
                                    </div>
                                    <div className={` ${derret === 'Departure' ? 'd-bock' : 'd-none'}`}>
                                        <div className="times">
                                            <h5>Departure from {getcity()?.fromcity}</h5>
                                            <div className="listContainer">
                                                {
                                                    timeSlots?.map((slot: any, index: any) => {
                                                        return (
                                                            <div key={`departure${slot?.id}${index}`} className="list">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox" id={`departure${slot?.id}`}
                                                                        className="form-check-input d-none"
                                                                        checked={timeFilters?.Departure?.ids?.includes(slot?.id)}
                                                                        onChange={(e) => {
                                                                            handleChangeTimeSlotFilter(
                                                                                'Departure',
                                                                                slot?.id,
                                                                                slot,
                                                                                e.target.checked
                                                                            )
                                                                        }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={`departure${slot?.id}`}>
                                                                        <p> {slot?.label} </p>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="times">
                                            <h5>Arrival at {getcity()?.tocity}</h5>
                                            <div className="listContainer">
                                                {
                                                    timeSlots?.map((slot, index) => {
                                                        return (
                                                            <div key={`arrival${slot?.id}${index}`} className="list">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox" id={`arrival${slot?.id}`}
                                                                        className="form-check-input d-none"
                                                                        checked={timeFilters?.Arrival?.ids?.includes(slot?.id)}
                                                                        onChange={(e) => {
                                                                            handleChangeTimeSlotFilter(
                                                                                'Arrival',
                                                                                slot?.id,
                                                                                slot,
                                                                                e.target.checked
                                                                            )
                                                                        }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={`arrival${slot?.id}`}>
                                                                        <p> {slot?.label} </p>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={` ${derret === 'Return' ? 'd-bock' : 'd-none'}`}>
                                        <div className="times">
                                            <h5>Departure from {getcity()?.tocity}</h5>
                                            <div className="listContainer">
                                                {
                                                    timeSlots?.map((slot, index) => {
                                                        return (
                                                            <div key={`returndeparture${slot?.id}${index}`} className="list">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox" id={`returndeparture${slot?.id}`}
                                                                        className="form-check-input d-none"
                                                                        checked={timeFilters?.ReturnDeparture?.ids?.includes(slot?.id)}
                                                                        onChange={(e) => {
                                                                            handleChangeTimeSlotFilter(
                                                                                'ReturnDeparture',
                                                                                slot?.id,
                                                                                slot,
                                                                                e.target.checked
                                                                            )
                                                                        }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={`returndeparture${slot?.id}`}>
                                                                        <p> {slot?.label} </p>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="times">
                                            <h5>Arrival at {getcity()?.fromcity}</h5>
                                            <div className="listContainer">
                                                {
                                                    timeSlots?.map((slot, index) => {
                                                        return (
                                                            <div key={`returnarrival${slot?.id}${index}`} className="list">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox" id={`returnarrival${slot?.id}`}
                                                                        className="form-check-input d-none"
                                                                        checked={timeFilters?.ReturnArrival?.ids?.includes(slot?.id)}
                                                                        onChange={(e) => {
                                                                            handleChangeTimeSlotFilter(
                                                                                'ReturnArrival',
                                                                                slot?.id,
                                                                                slot,
                                                                                e.target.checked
                                                                            )
                                                                        }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={`returnarrival${slot?.id}`}>
                                                                        <p> {slot?.label} </p>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }


                                                {/* <div className="list">
                                                    <div className="form-check">
                                                        <input className="form-check-input d-none"
                                                            onChange={(e) => {
                                                                handleTimeSlotFilter(
                                                                    'ReturnArrivalStartTime',
                                                                    'ReturnArrivalEndTime',
                                                                    '06:00:00',
                                                                    null,
                                                                    'Return',
                                                                    e.target.checked
                                                                )
                                                            }}
                                                            checked={
                                                                "06:00:00" === formFilterTime?.ReturnArrivalStartTime
                                                                && formFilterTime?.ReturnArrivalEndTime === null
                                                            }
                                                            type="checkbox"
                                                            name="return Arrival times" id="returnarrivalBefore6am" />
                                                        <label className="form-check-label" htmlFor="returnarrivalBefore6am">
                                                            <p>Before 6 AM</p>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="list">
                                                    <div className="form-check">
                                                        <input className="form-check-input d-none"
                                                            onChange={(e) => {
                                                                handleTimeSlotFilter(
                                                                    'ReturnArrivalStartTime',
                                                                    'ReturnArrivalEndTime',
                                                                    '06:00:00',
                                                                    '12:00:00',
                                                                    'Return',
                                                                    e.target.checked
                                                                )
                                                            }}
                                                            checked={
                                                                "06:00:00" === formFilterTime?.ReturnArrivalStartTime
                                                                && "12:00:00" === formFilterTime?.ReturnArrivalEndTime
                                                            }
                                                            type="checkbox"
                                                            name="return Arrival times" id="returnarrival6amto12pm" />
                                                        <label className="form-check-label" htmlFor="returnarrival6amto12pm">
                                                            <p>6 AM to 12 PM</p>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="list">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input d-none"
                                                            onChange={(e) => {
                                                                handleTimeSlotFilter(
                                                                    'ReturnArrivalStartTime',
                                                                    'ReturnArrivalEndTime',
                                                                    '12:00:00',
                                                                    '18:00:00',
                                                                    'Return',
                                                                    e.target.checked
                                                                )
                                                            }}
                                                            checked={
                                                                "12:00:00" === formFilterTime?.ReturnArrivalStartTime
                                                                && "18:00:00" === formFilterTime?.ReturnArrivalEndTime
                                                            }
                                                            type="checkbox"
                                                            name="return Arrival times" id="returnarrival12pmto6pm" />
                                                        <label className="form-check-label" htmlFor="returnarrival12pmto6pm">
                                                            <p>12 PM to 6 PM</p>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="list">
                                                    <div className="form-check">
                                                        <input className="form-check-input d-none"
                                                            onChange={(e) => {
                                                                handleTimeSlotFilter(
                                                                    'ReturnArrivalStartTime',
                                                                    'ReturnArrivalEndTime',
                                                                    null,
                                                                    '19:00:00',
                                                                    'Return',
                                                                    e.target.checked
                                                                )
                                                            }}
                                                            checked={
                                                                formFilterTime?.ReturnArrivalStartTime === null
                                                                && "18:00:00" === formFilterTime?.ReturnArrivalEndTime
                                                            }
                                                            type="checkbox" name="return Arrival times" id="returnarrivalAfter6pm" />
                                                        <label className="form-check-label" htmlFor="returnarrivalAfter6pm">
                                                            <p>After 6 PM</p>
                                                        </label>
                                                    </div>
                                                </div> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFilter4">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false"
                                    aria-controls="panelsStayOpen-collapseFour">
                                    Price
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse show"
                                aria-labelledby="leftFilter4">
                                <div className="accordion-body">
                                    <label htmlFor="customRange1" className="form-label">₹{minMaxPrice?.minPrice} <span> - </span> ₹{priceFilter}</label>
                                    <input type="range"
                                        min={minMaxPrice?.minPrice}
                                        max={minMaxPrice?.maxPrice}
                                        value={priceFilter}
                                        onChange={(e) => hendlechage("price", e.target?.value)}
                                        onPointerUp={handlePriceChangeComplete}
                                        onMouseUp={handlePriceChangeComplete}
                                        className="form-range"
                                        id="customRange1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AlertModel
                showModal={showModal}
                onClosedModal={onClosedModal}
                messages='If you unsubscribe, you will miss the latest fare & flight details.'
                clickOnSecondButton={() => updatePriceAlert(false)}
                secondButtonTitle='unsubscribe'
            />

            <AlertModel
                showModal={unsubscribeSuccessfully}
                onClosedModal={() => setUnsubscribeSuccessfully(false)}
                messages='Successfully unsubscribed.'
                clickOnSecondButton={() => setUnsubscribeSuccessfully(false)}
                secondButtonTitle='Okay'
            />
        </>
    )
}

export default FlightFilter